<template>
    <div :class="isHome ? '' : 'container mx-auto px-2 py-4'">
    <h1 v-if="!isHome">Anmeldeformular</h1>
    <form @submit.prevent="onLogin" novalidate :class="isHome ? 'text-white' : 'box'">
        <h2 :class="isHome ? 'text-white' : ''">Anmeldung zum Online-Heizkostenvergleich</h2>
        <div class="text-xs mb-4">Um den Online-Heizkostenvergleich nutzen zu können, geben Sie bitte Ihren Benutzernamen (Ihre E-Mail-Adresse) und ihr Passwort ein.</div>
        <div class="flex flex-wrap" :class="isHome ? '-mx-4' : '-mx-4'">
            <base-input v-model.trim="loginEmail"
                        :id-prefix="formInputPrefix"
                        :border-color="isHome ? 'border-white': ''"
                        :label-color="isHome ? 'text-white': ''"
                        :label-color-hover="isHome ? 'text-white': ''"
                        :border-color-hover="isHome ? 'border-white': ''"
                        class="w-full px-4"
                        :class="isHome ? '':'md:w-6/12'"
                        name="email"
                        :validations="[{ condition: v$.loginEmail.required &&  v$.loginEmail.$error && loginEmail == '',text:'Bitte trage deine E-Mail Adresse ein!'},{ condition: v$.loginEmail.email.$invalid &&  v$.loginEmail.$error ,text:'Bitte trage deine korrekte E-Mail Adresse ein!'}]"
                        ref="login-email"
                        :type="'text'" label="default.email" required/>

            <base-input v-model.trim="password"
                        :id-prefix="formInputPrefix"
                        :border-color="isHome ? 'border-white': ''"
                        :label-color="isHome ? 'text-white': ''"
                        :label-color-hover="isHome ? 'text-white': ''"
                        :border-color-hover="isHome ? 'border-white': ''"
                        class="w-full px-4"
                        :class="isHome ? '':'md:w-6/12'"
                        name="password"
                        :validations="[{ condition: v$.password.required &&  v$.password.$error, text:'Bitte tragen Sie Ihr Passwort ein!'}]"
                        ref="login-password"
                        :type="'password'" label="default.password" required/>
            <div class="w-full px-4 mb-2">
                <base-checkbox
                    :id-prefix="formInputPrefix"
                    name="privacy"
                    :is-invert="isHome"
                    :validations="[{ condition: !v$.privacy.$model && submitted, text:'Bitte bestätigen!'}]"
                    v-model:checked="privacy"
                    :label-class="isHome? 'text-white' : ''"
                >
                    Ich stimme den <router-link to="privacy" class="underline">Datenschutzhinweisen</router-link> und den <a href="https://www.bdew.de/rechtliches/" target="_blank" class="underline">rechtlichen Hinweisen</a> zu
                </base-checkbox>
            </div>
            <div class="w-full px-4 flex items-center" :class="isHome ? 'justify-start mt-4' : 'justify-end'">
                <router-link to="forgot" class="mr-6">Passwort vergessen?</router-link>
                <base-button type="submit" :loading="axiosCall" class="button-min-width" :button-class="isHome ? 'white' : ''">
                    Anmelden
                </base-button>
            </div>
        </div>
    </form>
    </div>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {email, required} from '@vuelidate/validators'
import {ref, computed, nextTick, getCurrentInstance} from 'vue'
import {useRouter} from 'vue-router'
import {useStore} from "vuex";
import {isChecked} from '@/utils/validators'

export default {
    props: {
        isHome: {
            type: Boolean,
            required: false,
            default: false
        },
        formInputPrefix: {
            type: String,
            required: false,
            default: 'login'
        }
    },
    setup() {
        const loginEmail = ref('');
        const privacy = ref(false);
        const password = ref('');
        const passwordForgotten = ref(false);
        const axiosCall = ref(false);
        const submitted = ref(false);
        const passwordEmail = ref('');
        const store = useStore();
        const router = useRouter();
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const rules = computed(() => ({
            loginEmail: {required, email},
            password: {required},
            privacy: {isChecked},
        }))

        const v$ = useVuelidate(rules, {password, loginEmail})

        const onLogin = () => {
            submitted.value = true
            v$.value.$touch()

            if (v$.value.$error || !privacy.value) return

            axiosCall.value = true

            const loginData = {
                email: loginEmail.value,
                password: password.value,
            }

            store.dispatch('Customer/login', loginData).then(function () {
                const redirect = router.currentRoute.value.query.redirect;

                console.log('redirect', redirect)
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: 'Erfolgreich angemeldet!',
                    type: 'success'
                });

                if(redirect) {
                    const redirecUrl = (router.currentRoute.value.fullPath).replace("/login?redirect=", "")
                    console.log('redirecUrl',redirecUrl)
                    router.push(redirecUrl);
                } else {
                    router.push('/projects');
                }

            }).catch(err => {
                console.log(err);
                axiosCall.value = false;
                emitter.emit("flash-message", {
                    text: 'login error',
                    type: 'error'
                })
            })

        }

        return {
            loginEmail,
            password,
            passwordEmail,
            passwordForgotten,
            axiosCall,
            onLogin,
            v$,
            privacy,
            submitted
        }

    }
}
</script>
